/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text ,TouchableOpacity} from 'react-native'
import styles from './Styles/FooterButtonStyle'

export default class FooterButton extends Component {
  

  render() {
    const {disabled, onPress, style, title }  = this.props
    const containerStyles = [styles.container, style]
    if (disabled) {
      containerStyles.push(styles.disabled)
    }
    return (
      <TouchableOpacity
        disabled={disabled}
        onPress={onPress}
        style={containerStyles}>
        <Text style={styles.titleText}>{title}</Text>
      </TouchableOpacity>
    )
  }
}
